import {
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Typography,
  useTheme,
  SvgIconProps
} from "@mui/material";
import React from "react";
import { CaretRightIcon } from "../icons";
import { IconCircleWrapper } from "..";

export interface MenuItemIcon {
  component: React.ComponentType<SvgIconProps>;
  props: SvgIconProps;
  backgroundColor: string;
}

export interface MenuListItemProps {
  id: string;
  title: string;
  iconConfig: MenuItemIcon;
  onClick?: () => void;
  rightContent?: React.ReactNode;
  disabled?: boolean;
  translationNamespace?: string;
}

const MenuListItem: React.FC<MenuListItemProps> = ({
  id,
  title,
  iconConfig,
  onClick,
  rightContent,
  disabled = false
}) => {
  const theme = useTheme();
  const IconComponent = iconConfig.component;

  return (
    <ListItem key={id} disablePadding>
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          overflow: 'hidden',
          backgroundColor: theme.palette.common.white,
          borderRadius: 1.5,
          opacity: disabled ? 0.5 : 1
        }}
      >
        <ListItemButton
          onClick={onClick}
          disabled={disabled}
          sx={{
            p: 1,
            gap: 1,
            display: 'flex',
            alignItems: 'center',
            fontWeight: 400,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
            '&.Mui-disabled': {
              opacity: 0.5
            }
          }}
        >
          <IconCircleWrapper size={36} bgcolor={iconConfig.backgroundColor}>
            <IconComponent
              {...iconConfig.props}
              style={{
                fontSize: 24,
                color: (iconConfig.props.sx as { color?: string })?.color ?? 'white'
              }}
            />
          </IconCircleWrapper>

          <ListItemText
            primary={title}
          />

          {rightContent && (
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.text.secondary,
                mr: 1
              }}
            >
              {rightContent}
            </Typography>
          )}

          <CaretRightIcon style={{ fontSize: 24 }} />
        </ListItemButton>
      </Paper>
    </ListItem>
  );
};

export default MenuListItem; 